"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var BruteIcon = /** @class */ (function (_super) {
    __extends(BruteIcon, _super);
    function BruteIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BruteIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 8.1890582,16.358316 -0.773908,-0.651387 0.07225,-1.782743 c 0.07085,-1.748092 0.45363,-5.0305381 1.111428,-9.5308201 0.545605,-3.73272299 0.651434,-4.40092399 0.690443,-4.35939199 0.02049,0.02182 0.230621,1.29344899 0.466954,2.82584899 1.0816188,7.013301 1.6580078,13.0528111 1.2457128,13.0528111 -0.09744,0 -0.444946,0.246842 -0.772247,0.548537 C 9.4499522,17.17991 9.1470392,17.164643 8.1890532,16.35832 Z m -3.54312,0.148564 c -0.05028,-0.05028 -0.09142,-0.95335 -0.09142,-2.006818 0,-1.095758 -0.07059,-2.151002 -0.16496,-2.46598 C 4.1904072,11.369374 3.5325052,10.70316 2.5058122,10.126537 1.5534152,9.5916399 0.63735118,8.8629619 0.33147921,8.3969769 c -0.19252,-0.293299 -0.245932,-0.817625 -0.302387,-2.968435 -0.03771,-1.436719 -0.06108,-2.62999 -0.05192,-2.651714 0.0091,-0.02172 0.20615,0.255973 0.437769,0.617104 0.23162097,0.36113 0.58703599,1.242849 0.78980999,1.959375 0.202774,0.716525 0.468606,1.418829 0.590736,1.560675 0.12213,0.141846 0.98161,0.617769 1.909956,1.057608 1.859799,0.881151 2.661939,1.440656 3.001154,2.0933521 0.257796,0.496032 0.259025,1.194608 0.0069,3.919437 l -0.170526,1.842935 -0.422556,0.109154 c -0.232406,0.06003 -0.535094,0.233506 -0.672641,0.385495 -0.24785,0.273869 -0.625727,0.361016 -0.801825,0.184917 z M 13.135533,16.335234 C 12.998582,16.183906 12.688179,15.994629 12.44575,15.91462 l -0.440784,-0.145471 -0.186705,-2.156687 c -0.219002,-2.529736 -0.209564,-3.050314 0.06492,-3.581116 0.32776,-0.6338191 0.967515,-1.0780641 2.876382,-1.9973591 0.9868,-0.475233 1.89552,-0.979675 2.01939,-1.120983 0.12387,-0.141308 0.35527,-0.735829 0.51423,-1.321157 0.30615,-1.127337 0.68968,-2.027265 1.08044,-2.535229 0.22699,-0.295059 0.23556,-0.201208 0.20035,2.194146 -0.0499,3.396973 -0.0601,3.41648 -2.58071,4.9392011 -0.94905,0.573338 -1.53067,1.109851 -1.7439,1.608644 -0.0806,0.18856 -0.18134,1.330201 -0.22386,2.536981 -0.0733,2.079939 -0.092,2.196244 -0.35915,2.234466 -0.155,0.02218 -0.39388,-0.08349 -0.530825,-0.234822 z" }))));
    };
    return BruteIcon;
}(react_1.Component));
exports.default = BruteIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/BruteIcon.tsx
// module id = 786
// module chunks = 0